import { render } from "./StaffList.vue?vue&type=template&id=4fd38d7c&scoped=true"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"

import "./StaffList.vue?vue&type=style&index=0&id=4fd38d7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd38d7c"]])

export default __exports__